import { HStack } from "@/components/layout/HStack";
import { VStack } from "@/components/layout/VStack";
import { Button } from "@/components/ui/Button/Button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/Collapsible/Collapsible";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/Tooltip/Tooltip";
import { CalendarSync, Eye, EyeClosed } from "lucide-react";
import { useState } from "react";
import { OpenSignupsTable } from "./OpenSignupDataTable";

const OpenSignups = ({
  data,
  loading,
  onOpen,
}: {
  data: {
    sessions: any[];
    rotations: any[];
  };
  loading: boolean;
  onOpen: (rotationId: string, sessionId: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      style={{ marginTop: "-8px" }}
    >
      <VStack gap="2rem">
        <VStack gap={0}>
          <HStack>
            <h3
              style={{
                fontSize: "var(--text-lg)",
                lineHeight: "var(--line-height-lg)",
                fontWeight: "var(--font-bold)",
              }}
            >
              Open Sign-Ups
            </h3>
            <Tooltip>
              <TooltipTrigger asChild>
                <CollapsibleTrigger asChild>
                  <Button variant="ghost" size="icon-small">
                    {open ? <EyeClosed /> : <Eye />}
                  </Button>
                </CollapsibleTrigger>
              </TooltipTrigger>
              <TooltipContent>
                {open ? "Hide" : "Show"} open sign-ups section.
              </TooltipContent>
            </Tooltip>
          </HStack>
          <p style={{ color: "var(--muted-foreground)" }}>
            Sessions open for sign-up that you haven't yet enrolled in.
          </p>
        </VStack>
        <CollapsibleContent>
          {loading ? (
            <Skeleton style={{ width: "100%", height: "512px" }} />
          ) : data.rotations.length < 1 ? (
            <Empty style={{ borderColor: "var(--secondary-border)" }}>
              <EmptyHeader>
                <EmptyMedia variant="icon">
                  <CalendarSync />
                </EmptyMedia>
                <EmptyTitle>No Sessions Found</EmptyTitle>
                <EmptyDescription>
                  No sessions found with open sign-ups. If you believe this is
                  an error please refresh.
                </EmptyDescription>
              </EmptyHeader>
            </Empty>
          ) : (
            <OpenSignupsTable data={data} onOpen={onOpen} />
          )}
        </CollapsibleContent>
      </VStack>
    </Collapsible>
  );
};

export { OpenSignups };
